import { PF_CHROME_WEBAPP_MODAL_CLOSE, PF_CHROME_WEBAPP_ATTACH_CONTENT } from 'constants/actionTypes';

export const closeModal = (context) => {
  window.parent.postMessage({
    type: PF_CHROME_WEBAPP_MODAL_CLOSE,
    payload: context
  }, "*")
}

export const attachContent = (context) => {
  context = JSON.parse(JSON.stringify(context));
  window.parent.postMessage({
    type: PF_CHROME_WEBAPP_ATTACH_CONTENT,
    payload: context
  }, "*")
}